import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import PhoneSvg from '#srcIcons/phone.svg';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailContactListCss from '../assets/model-detail/model-detail-contact-list.module.scss';

const Phone: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      contactData,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (contactData.isEmpty || !contactData.phone) {
    return null;
  }

  if (!isBot && isDeleted) {
    return (
      <div className={modelDetailContactListCss.modelDetailContactList__item}>
        <SvgIcon Component={PhoneSvg} size="1em" isWithoutStroke />
        +
        {Array(contactData.phone.value.length - 1).fill('*').join('')}
      </div>
    );
  }

  return (
    <a
      href={contactData.phone.url}
      className={modelDetailContactListCss.modelDetailContactList__item}
      target="_blank"
      rel="noreferrer"
    >
      <SvgIcon Component={PhoneSvg} size="1em" isWithoutStroke />
      {contactData.phone.value}
    </a>
  );
};

export { Phone };
